import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getAllPendingProperties } from "../../../services/propertyService";
import { logoutUser } from "../../../services/authService";
import Cookies from "js-cookie";

import {
  FaTachometerAlt,
  FaUsers,
  FaBuilding,
  FaProjectDiagram,
  FaClipboardCheck,
  FaEnvelope,
  FaUserCog,
  FaSignOutAlt,
  FaNewspaper,
} from "react-icons/fa";

import * as useAuth from "../../../hooks/pages/useAuth";

const AdminSidebar = ({ isOpen, onClose }) => {
  const [pendingProperties, setPendingProperties] = useState(0);

  const navigate = useNavigate();
  const { user } = useAuth.useAuth();

  useEffect(() => {
    const fetchPendingData = async () => {
      try {
        const propData = await getAllPendingProperties(
          { status: "pending" },
          1,
          1
        );

        setPendingProperties(propData?.total || 0);
      } catch (error) {
        console.error(
          "Lấy số lượng BĐS chờ phê duyệt thất bại:",
          error
        );
      }
    };

    fetchPendingData();
  }, []);

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      Cookies.remove("user");
      Cookies.remove("accessToken");
      navigate("/login");
    }
  };

  const menuItems = [
    {
      label: "Tổng quan",
      path: "/admin/dashboard",
      icon: <FaTachometerAlt />,
    },
    {
      label: "Người dùng",
      path: "/admin/users",
      icon: <FaUsers />,
    },
    {
      label: "Bất động sản",
      path: "/admin/properties",
      icon: <FaBuilding />,
    },
    {
      label: "Dự án",
      path: "/admin/projects",
      icon: <FaProjectDiagram />,
    },
    {
      label: `Chưa phê duyệt BĐS${
        pendingProperties > 0
          ? ` (${pendingProperties})`
          : ""
      }`,
      path: "/admin/notapproved",
      icon: <FaClipboardCheck />,
    },
    {
      label: "Tin tức",
      path: "/admin/news",
      icon: <FaNewspaper />,
    },
    {
      label: "Liên hệ",
      path: "/admin/contacts",
      icon: <FaEnvelope />,
    },
    {
      label: "Cài đặt cá nhân",
      path: "/admin/settings",
      icon: <FaUserCog />,
    },
  ];

  return (
    <aside
      className={`fixed top-0 left-0 z-50 h-full w-64 bg-white dark:bg-gray-800 shadow-lg p-4 flex flex-col transition-transform duration-300 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-xl font-bold text-[#0c2c4d] dark:text-orange-400">
          {user
            ? `${user.name || user.email} (${user.role})`
            : "Admin Panel"}
        </span>

        <button
          onClick={onClose}
          className="text-gray-600 dark:text-gray-300 hover:text-red-500 text-xl"
        >
          &times;
        </button>
      </div>

      {/* Menu */}
      <nav className="flex flex-col space-y-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 p-3 rounded-lg transition
              ${
                isActive
                  ? "bg-blue-500 text-white"
                  : "text-gray-700 dark:text-gray-200 hover:bg-blue-100 dark:hover:bg-gray-700"
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="mt-auto pt-4 border-t border-gray-200 dark:border-gray-700">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full p-3 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
        >
          <FaSignOutAlt />
          <span>Đăng xuất</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;